import { useState } from "react";
import { RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { api, errorText } from "@/lib/api";
import "@/components/teamproj/TeamProjections.css";

// Fast, network-free rebuild of team ratings (team_adv) from stored game data.
// Primary use: after deploying a projection-logic fix, click this on the LIVE site so the
// production ratings reflect the new code immediately (no heavy daily re-scrape needed).
export function RebuildRatingsCard() {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/jobs/rebuild-ratings");
      toast.success(data.message || "Ratings ξαναχτίστηκαν");
    } catch (e) { toast.error(errorText(e)); } finally { setBusy(false); }
  };
  return (
    <div className="tp-root mt-6">
      <div className="tp-card" data-testid="rebuild-ratings-card">
        <h4><RefreshCw size={13} className="inline mr-1" />ΞΑΝΑΧΤΙΣΕ RATINGS ΟΜΑΔΩΝ <small>(admin · γρήγορο, χωρίς νέο scraping)</small></h4>
        <p className="tp-note" style={{ marginBottom: 10 }}>
          Ξαναϋπολογίζει τα ratings (επίθεση/άμυνα/ρυθμός) από τα ήδη αποθηκευμένα παιχνίδια. Χρήσιμο μετά από deploy αλλαγής στο μοντέλο, ώστε οι προβλέψεις στο live να ενημερωθούν αμέσως.
        </p>
        <button type="button" className="tv-vbtn primary" onClick={run} disabled={busy} data-testid="rebuild-ratings-btn">
          <RefreshCw size={14} className={busy ? "animate-spin" : ""} /> {busy ? "Ξαναχτίζεται…" : "Ξαναχτίσε τώρα"}
        </button>
      </div>
    </div>
  );
}
